import React, { useState, useContext, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FaBars } from 'react-icons/fa'
import ToolbarStyle from './css/ToolbarStyle'
import { appContext } from '../../../App'
import Login from '../../login/Login'

export const showMenu = (show) => {
  //1. Another way to do it
  const container = document.querySelector('.container')
  if (show) {
    if (container.classList.contains('hide-menu')) container.classList.remove('hide-menu')
  } else
    if (!container.classList.contains('hide-menu')) container.classList.add('hide-menu')
}

function Toolbar() {
  const app = useContext(appContext)
  const { logOut } = app
  const [date, setDate] = useState(new Date())

  const showMenuToggle = () => {
    const container = document.querySelector('.container')

    // Simplest way to do it
    container.classList.toggle('hide-menu')

    // 1. Another way to do it
    // if (container.classList.contains('hide'))
    //   container.classList.remove('hide')
    // else
    //   container.classList.add('hide')

    // 2. Another way to do it
    // container.style.gridTemplateColumns = show_menu ? '1fr 4fr' : '0fr 4fr'
    // show_menu = !show_menu
  }

  const onClickClientUserOptions = async (e) => {
    const id = e.target.id
    // Wether change user or logout
    // Save it to log
    await logOut()

    switch(id) {
      case 'change-user':
        ReactDOM.render(<Login clientID={app.clientID}/>, document.getElementById('root'))
        break
      case 'log-out':
        window.location.reload(false)
        break
      default:
    }
  }

  useEffect(() => {
    // Update every one second
    const timerID = setInterval(() => {
      setDate(new Date())
    }, 1000)

    return(() => { clearInterval(timerID) })

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div id="toolbar">
        <button
          onClick={showMenuToggle}
          className='pospro-action-btn'>
          <FaBars />
        </button>
        <div id="logo-container">
          {/*<span id="brand">NPOS</span>&nbsp;<span id="version">Version 1.0.0</span>*/}
          <img id="pos22-logo" src='pos22 logo.png' alt='pos22 logo' width='120' height='45'/>
        </div>
        <div id="loading-indicator-container">{/** loading indicator here */}</div>
        <div className='timezone-wrapper'>
          <div className='timezone'>{ app.client.company_address.time_zone }</div>
          <hr className='thin-hr'/>
          {/*<div>{date.toLocaleString('en', { timeZone: app.client.time_zone })}</div>*/}
          <div>{date.toLocaleString('en', { timeZone: app.client.company_address.time_zone })}</div>
        </div>
        <button
          style={{display: 'block'}}
          id="client-user-button">
          <span>
          {
            (app.client.signed_in === 'admin')
            ? <b>{app.client.admin_login_details.user_name}</b>
            : app.client.signed_in.login_details.user_name
          }
          </span>@{app.client.company_profile.company_name}&nbsp;<FontAwesomeIcon icon='caret-down'/>
        </button>
        <div className='dropdown-window'>
          <button
            id='change-user'
            onClick={onClickClientUserOptions}>
            <FontAwesomeIcon icon='user-friends'/>&nbsp;Change User
          </button>
          <button
            id='log-out'
            onClick={onClickClientUserOptions}>
            <FontAwesomeIcon icon='power-off'/>&nbsp;Logout
          </button>
        </div>
      </div>
      <ToolbarStyle />
    </React.Fragment>
  )
}

export default React.memo(Toolbar)